module.exports = __webpack_public_path__ + "img/store-icon.3fa26d24.svg";